import { produce } from 'immer'
import { dispatch } from '@rematch/core'
import keyBy from 'lodash/keyBy'
import sortBy from 'lodash/sortBy'
import api from './api'

export default {
    state: {
        list: { },
        nameFilter: '',
        selected: null
    },

    reducers: {
        set: produce((draft, organisations = []) => {
            draft.list = keyBy(organisations, item => item.id)
        }),

        select: produce((draft, id) => {
            draft.selected = draft.list[id]
        }),

        deselect: produce(draft => {
            draft.selected = null
        }),

        filter: produce((draft, nameFilter) => {
            draft.nameFilter = nameFilter
        })
    },

    selectors: {
        list(state) {
            return sortBy(Object.values(state.organisations.list), item => item.organisatieNaam)
        },

        selected(state) {
            return state.organisations.selected
        },

        nameFilter(state) {
            return state.organisations.nameFilter
        }
    },

    effects: {
        async load() {
            const res = await api.get()

            if (res && res.data) {
                dispatch.organisations.set(res.data.value)
            }
        }
    }
}
